const injectUrlQuery = (urlQuery) => {
    return (cb) => {
        return (params) => {
            return cb({
                ...params,
                urlQuery,
            })
        }
    }
}

export default injectUrlQuery
